import React from 'react';
import '../styles/Hr.css';

function Hr(props) {
    return (
<div className="hr">
    <hr />
</div>
    );
}

export default Hr;